import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import config from '../../config'
export const apiSlice = createApi({
  reducerPath: 'apiProductSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: config.ServerURL,
  }),
  tagTypes: ['Product'],
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: () => 'p/',
      providesTags: ['Product'],
    }),
  }),
})
export const { useGetProductsQuery } = apiSlice